// Better-Auth の user テーブル追加フィールド定義 (SSoT)。
//
// サーバ (apps/api: betterAuth `user.additionalFields`) とクライアント
// (apps/admin: `inferAdditionalFields`) で同一定義を共有し、両者の型ドリフトを防ぐ。
// これにより admin 側で session.user.role / status / publicId が型付きで参照でき、
// `as unknown as { ... }` キャストが不要になる (C-8)。
//
// `as const` は better-auth の FieldAttribute が要求するリテラル型 (`type: "string"`) を
// 保持するために必須。値を緩めると both 側の推論が壊れる。
export const authUserAdditionalFields = {
  publicId: { type: "string", required: false, input: false },
  role: { type: "string", required: false, input: false },
  status: { type: "string", required: false, input: false },
} as const;
